import * as React from "react";

import { Button, Callout } from "@blueprintjs/core";
import Loader from "~/components/Loader";
import client from "~/graphql/client";
import {
  IModerateOptionsInput,
  IModerationOptionInput,
  MODERATE_OPTIONS_MUTATION
} from "~/graphql/mutations/optionModeration/moderateOptions";
import {
  IOption,
  OPTIONS_PENDING_MODERATION_QUERY,
  OptionsPendingModeration,
  OptionsPendingModerationVariables
} from "~/graphql/queries/optionModeration/optionsPendingImageModeration";
import { ModerationOptionStatus } from "~/graphql/types";
import MainLayout from "~/layouts/MainLayout";
import getOptionImage from "~/util/getOptionImage";
import ModerationActivityManager from "~/util/registerModerationActivity";
import ProductOptionListContainer from "./ProductOptionListContainer";

interface IState {
  input: IModerateOptionsInput;
  loading: boolean;
  options: IOption[];
}

export default class ProductOptionModerationContainer extends React.Component<
  {},
  IState
> {
  public readonly state: IState = {
    input: {
      options: []
    },
    loading: false,
    options: []
  };

  public render() {
    const { input, loading, options } = this.state;

    if (loading) {
      return <Loader />;
    }

    if (options.length === 0) {
      return (
        <Callout intent="danger" title="No more options">
          No more options left to moderate.
        </Callout>
      );
    }

    return (
      <MainLayout
        title={<h3>Select the images that do not match our standards</h3>}
        actions={
          <Button large={true} intent="success" onClick={this.handleSubmit}>
            Save and next
          </Button>
        }
      >
        <ProductOptionListContainer
          input={input}
          options={options}
          setOptionInput={this.setOptionInput}
        />
      </MainLayout>
    );
  }

  public componentDidMount() {
    this.fetchOptions();
  }

  private handleSubmit = async () => {
    this.setState({ loading: true });
    await client.mutate({
      mutation: MODERATE_OPTIONS_MUTATION,
      variables: {
        input: this.state.input
      }
    });
    ModerationActivityManager.registerModerationActivity(
      "option_moderation_page",
      `${this.state.input.options.length}`
    );
    this.setState({ loading: false });
    this.fetchOptions();
  };

  private setOptionInput = (
    nesOptionId: string,
    input: IModerationOptionInput,
    sameImage: boolean = true
  ) => {
    if (sameImage) {
      const currentOption = this.state.options.find(
        option => option.id === nesOptionId
      );
      const currentOptionImage = getOptionImage(currentOption!);

      this.state.options
        .filter(option => getOptionImage(option) === currentOptionImage)
        .map(option => this.setOptionInput(option.id, input, false));

      return;
    }

    this.setState((prevState: IState) => {
      const {
        input: { options }
      } = prevState;

      const existingOptionIndex = options.findIndex(
        option => option.nesOptionId === nesOptionId
      );

      return {
        input: {
          options: [
            ...options.slice(0, existingOptionIndex),
            {
              ...options[existingOptionIndex],
              ...input,
              nesOptionId
            },
            ...options.slice(existingOptionIndex + 1)
          ]
        }
      };
    });
  };

  private async fetchOptions(count: number = 100) {
    this.setState({ loading: true });

    try {
      const { data } = await client.query<
        OptionsPendingModeration,
        OptionsPendingModerationVariables
      >({
        fetchPolicy: "network-only",
        query: OPTIONS_PENDING_MODERATION_QUERY,
        variables: { count }
      });

      if (data.options) {
        const inputOptions: IModerationOptionInput[] = data.options.map(
          (option): IModerationOptionInput => ({
            containsLogo: false,
            containsText: false,
            hasBackground: false,
            imageBroken: false,
            logoCoversProduct: false,
            nesOptionId: option.id,
            status: ModerationOptionStatus.SCREENED
          })
        );

        this.setState({
          input: {
            options: inputOptions
          },
          options: data.options
        });
      }
    } finally {
      this.setState({ loading: false });
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/ProductOptionModerationContainer.tsx